//@flow

import * as React from "react";
import { Routes, Route } from "react-router-dom";
import CreateOrder from "../component/CreateOrder";
import PageNotFound from "../component/PageNotFound";
import Unauthorized from "../component/Unauthorized";
import UploadSuccess from "../component/UploadSuccess";
import SomeThingWentWrong from "../component/SomethingWentWrong";
import PrivateRoute from "./PrivateRoute";
import CreateRouteManifest from "../component/CreateRouteManifest";
import { notification } from "antd";
import RoleBasedRoute from "./RoleBasedRoute";
import { Groups } from "../component/GroupCreation";
import { AssignGroup } from "../component/GroupAssign";
import { RiderBillingReport } from "../component/BillingReport";
import GenerateLink from "../component/GenerateLink/GenerateLink";
import TourPaymentSummary from "../component/TourPaymentSummary";

const type = {
  create_group: "create_group",
  rider_billing_report: "rider_billing_report",
  assign_group: "assign_group",
  upload_orders: "upload_orders",
  route_master: "route_master",
};

const AppRoutes = () => {
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (
    type,
    message,
    description,
    messageStyle = {},
    descriptionStyle = {}
  ) => {
    api[type]({
      message: (
        <span style={{ fontSize: "12px", width: "600px", ...messageStyle }}>
          {message}
        </span>
      ),
      description: (
        <span style={{ fontSize: "10px", width: "600px", ...descriptionStyle }}>
          {description}
        </span>
      ),
    });
  };
  return (
    <>
      {contextHolder}
      <Routes>
        <Route exact path="/unauthorized" element={<Unauthorized />} />
        <Route exact path="/:orderId/generateLink" element={<GenerateLink />} />
        <Route exact path="/tour-payment-summary" element={<TourPaymentSummary />} />
        <Route exact element={<RoleBasedRoute type={type.create_group} />}>
          <Route
            exact
            path="/groups"
            element={
              <Groups openNotificationWithIcon={openNotificationWithIcon} />
            }
          />
        </Route>
        <Route
          exact
          element={<RoleBasedRoute type={type.rider_billing_report} />}
        >
          <Route
            exact
            path="/rider-billing-report"
            element={
              <RiderBillingReport
                openNotificationWithIcon={openNotificationWithIcon}
              />
            }
          />
        </Route>
        <Route exact element={<RoleBasedRoute type={type.assign_group} />}>
          <Route
            exact
            path="/assign-group"
            element={
              <AssignGroup
                openNotificationWithIcon={openNotificationWithIcon}
              />
            }
          />
        </Route>
        <Route
          exact
          path="/home/*"
          element={
            <PrivateRoute>
              <Routes>
                <Route
                  exact
                  element={<RoleBasedRoute type={type.upload_orders} />}
                >
                  <Route
                    path="/create-order"
                    element={<CreateOrder version="v1" />}
                  />
                  <Route
                    path="/create-order-v2"
                    element={<CreateOrder version="v2" />}
                  />
                </Route>
                <Route path="/order-success" element={<UploadSuccess />} />
                <Route
                  exact
                  element={<RoleBasedRoute type={type.route_master} />}
                >
                  <Route
                    path="/route-master"
                    element={
                      <CreateRouteManifest
                        openNotificationWithIcon={openNotificationWithIcon}
                      />
                    }
                  />
                </Route>
                <Route
                  path="/something-went-wrong"
                  element={<SomeThingWentWrong />}
                />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </PrivateRoute>
          }
        />
        <Route exact path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
